<mat-dialog-content class="mat-typography">
	<p>
		<b>Como deseja exportar os dados.</b> <br />
		Em caso de e-mail iremos processar e enviar o arquivo no e-mail cadastrado.<br />
		Em caso de baixar agora, vamos processar o arquivo e fazer o download, esse processo pode demorar um pouco.
	</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button class="btn btn-secondary ms-2 d-flex align-items-center" [mat-dialog-close]="'email'">
		Receber via e-mail
	</button>
	<button class="btn btn-primary ms-2 d-flex align-items-center" [mat-dialog-close]="'now'">Baixar agora</button>
</mat-dialog-actions>
